module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_38-31d782264ca8aa2417f8e7c9af552b4a.png";